import reefLogo from "./public/Reef Pay.png"
import ePNLogo from "./public/ePN.png"
import secret from "./server/secret"

export const IS_REEF = secret.DATABASE_NAME === "reef"
export const IS_EPN = secret.DATABASE_NAME === "epn"
export const GATEWAY_LOGO = IS_EPN ? ePNLogo : reefLogo